exports = module.exports = require("../../../../node_modules/.0.28.7@css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".gyqyuI7dkHcsUr_krkC_C{position:relative}.gyqyuI7dkHcsUr_krkC_C ._3BFmLaDHqjzde4qQD4yNCG{float:right}.gyqyuI7dkHcsUr_krkC_C ._3BFmLaDHqjzde4qQD4yNCG .anticon{margin-right:5px}._3dMKXVoR6IKIKNZcFbPGPW{position:absolute;right:0;top:10px}", "", {"version":3,"sources":["/work/moapi/src/routes/project/components/ModuleMenu.less"],"names":[],"mappings":"AAAA,uBACE,iBAAmB,CACpB,AACD,gDACE,WAAa,CACd,AACD,yDACE,gBAAkB,CACnB,AACD,yBACE,kBAAmB,AACnB,QAAS,AACT,QAAU,CACX","file":"ModuleMenu.less","sourcesContent":[".wrapper {\n  position: relative;\n}\n.wrapper .icon {\n  float: right;\n}\n.wrapper .icon :global(.anticon) {\n  margin-right: 5px;\n}\n.addBtn {\n  position: absolute;\n  right: 0;\n  top: 10px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"wrapper": "gyqyuI7dkHcsUr_krkC_C",
	"icon": "_3BFmLaDHqjzde4qQD4yNCG",
	"addBtn": "_3dMKXVoR6IKIKNZcFbPGPW"
};


// WEBPACK FOOTER //
// ./node_modules/.0.28.7@css-loader?{"importLoaders":1,"minimize":true,"modules":true,"sourceMap":true}!./node_modules/.2.0.8@postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/assets/fonts/antd/iconfont/""}}!./src/routes/project/components/ModuleMenu.less